/**
 * The app's chevron. One shape, one file.
 *
 * Bootstrap Icons' compact chevron, which is what p2p puts on its card rows — a hairline
 * one unit thick on a 16 grid, rather than a stroked Feather glyph. It appears on every
 * card affordance and, mirrored, on every back control.
 *
 * WHY THIS IS A COMPONENT. The path was pasted into four places across three files. That
 * held until one of them was updated and the others were not: the back control on
 * /settings/language-appearance stayed on a Feather polyline at 1.5rem while /login and
 * /start moved to this glyph at 1.25rem, so two screens one tap apart wore different
 * arrows. Inlining a path is how that happens; there is nothing to keep in sync here.
 *
 * SIZE AND DIRECTION ARE THE CALLER'S. Both are per-context — a card chevron and a back
 * control are not the same size, and mirroring is a `transform: scaleX(-1)` on the back
 * ones — so they stay in the stylesheet next to the rest of that control's layout rather
 * than becoming props. Pass the class; the CSS does the rest.
 *
 * Decorative in every current use: the control it sits in carries the accessible name.
 */
export default function Chevron({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
      <path
        fillRule="evenodd"
        d="M6.776 1.553a.5.5 0 0 1 .671.223l3 6a.5.5 0 0 1 0 .448l-3 6a.5.5 0 1 1-.894-.448L9.44 8 6.553 2.224a.5.5 0 0 1 .223-.671"
      />
    </svg>
  );
}
